import { render, staticRenderFns } from "./CircleCard.vue?vue&type=template&id=0653cf5a&scoped=true"
import script from "./CircleCard.vue?vue&type=script&lang=js"
export * from "./CircleCard.vue?vue&type=script&lang=js"
import style0 from "./CircleCard.vue?vue&type=style&index=0&id=0653cf5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0653cf5a",
  null
  
)

export default component.exports